<template>
  <div style="margin-top: 5px">
  <Badge :count="count">
    <a @click="showEmailNews"><Icon type="email" size="50" color="#e3e8ee"></Icon></a>
  </Badge>
    <Button type="warning" size="small" @click="updateUserAllMessageNeedAlertStatus()">一键关闭弹窗提醒</Button>
  </div>
</template>
<script>
  import commonUtils from '@/tools/commonUtils.js'
  import bus from '@/eventBus.js'
//  import centerDealVue from '@/main.js'
  export default {
    data () {
      return {
        uid: '',
        count: 0,
        userNickName: '',
        rules: [],
        hasPermission: false,
        msg: [],
        openCount: -1,
        showCount: 0,
      }
    },
    methods: {
      getPersonMessageNotice () {
        let self = this
        self.$http.get('/message/getPersonMessage?needAlert=1&state=0').then(function (res) {
          if (res.data.data) {
            self.msg = res.data.data
            let list = self.msg
            if (list.length > 0) {
              for (self.openCount = 0; self.openCount < list.length; self.openCount++) {
                self.openMsg()
              }
            }
          }
        })
      },
      showEmailNews () {
        this.$router.push({path: '/message/personMessage'})
      },
      openMsg () {
        let self = this
        let index = self.openCount
        if (index < 0) {
          return
        }
        this.$Notice.config({
          top: 50,
          duration: 0,
        })
        this.$Notice.success({
          name: index + '',
          title: '站内消息提醒',
          render: h => {
            return h('div', [
              h('span', {style: {fontSize: '12px'}}, self.msg[index].content),
              h('br'),
              h('br'),
              h('Button', {on: {click: () => self.openMessageDetail(self.msg[index])}, style: {width: '80px', float: 'left'}}, '查看详情'),
              h('Button', {on: {click: () => self.handlerMsg(self.msg[index].id, index + '')}, style: {width: '80px', float: 'right'}}, '不再提示'),
            ])
          }
        })
      },
      openMessageDetail (msg) {
        let self = this
        this.$Notice.destroy()
        self.$router.push({path: '/message/personMessage', query: {tabName: commonUtils.getShortNumByTraceType(msg.type)}})
      },
      handlerMsg (id, item) {
        let self = this
        self.$http.post('/message/handlerMessage', {id: id})
        this.$Notice.close(item)
      },
      getMessageCount (getNotice) {
        let self = this
        this.$http.post('/message/getPersonMessageCount', {state: 0}).then(function (res) {
          if (res.status === 'ok') {
            self.count = res.data
            if (self.count > 0 && getNotice > 0) {
              self.getPersonMessageNotice()
            }
          }
        })
      },
      updateUserAllMessageNeedAlertStatus () {
        let self = this
        self.$Modal.confirm({
          title: '提示',
          content: '是否确认现有未处理信息不再弹出？',
          width: 300,
          loading: false,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            self.$Notice.destroy()
            self.$http.post('/message/notNeedAlert', {needAlert: 0}).then(function (res) {
              if (res.data > 0) {
                self.$Message.success('操作成功!')
              }
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    created () {
      this.getMessageCount(1)
    },
    mounted: function () {
      let self = this
      bus.$on('reloadMessageCount', (count) => {
        self.getMessageCount(count)
      })
    },
  }
</script>



// WEBPACK FOOTER //
// message.vue?28bb5613